import { Trans, useTranslation } from 'react-i18next';

import { Button, Modal, ModalContent, ModalFooter, Typography } from '@client/toolkit';

interface CancelRequestModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function CancelRequestModal({ open, onCancel, onConfirm }: CancelRequestModalProps) {
  const { t: tCommon } = useTranslation();

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal open={open} onClose={handleCancel}>
      <ModalContent>
        <div className="uppercase text-xs font-semibold p-4 text-center">
          {`${tCommon('confirm')} ${tCommon('cancel')}`}
        </div>
        <Typography align="center" className="px-4 py-4">
          <Trans t={tCommon} i18nKey={'cancelConfirm'} />
        </Typography>
      </ModalContent>
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleConfirm}>
          {tCommon('confirm')}
        </Button>
        <Button color="primary-dark" onClick={handleCancel}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
